import script from "./commonError.vue?vue&type=script&setup=true&lang=js"
export * from "./commonError.vue?vue&type=script&setup=true&lang=js"

import "./commonError.vue?vue&type=style&index=0&id=026c9c02&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/DLJY-Web-Test/example/main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-026c9c02"]])

export default __exports__